export const regexEscape = str => (str ? str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&") : null); // eslint-disable-line

export const searchCompare = (str = "", query) =>
  !query || str.toLowerCase().match(new RegExp(`\\b${regexEscape(query.toLowerCase())}`));
